<div class="row">
    <mat-card class="simply-map-card col-12 box-shadow">
        <mat-card-header class="row  justify-content-center">
            <mat-card-title class="col">Des stations partout en France</mat-card-title>
            <mat-card-subtitle  class="col">Découvrez les services près de vous</mat-card-subtitle>
        </mat-card-header>
        <mat-card-actions class="col-12">
          <div class="row">
              <p class="col-12">Seclectionnez une comunauté dans la liste ou sur la carte pour découvrir les offres</p>
              <mat-form-field class="col-10">

                <mat-label>Nos Communauté (à changer)</mat-label>
                <mat-select>
                    <mat-option >
                        <!-- <mat-option *ngFor="let food of foods" [value]="food.value"> -->
                          COM
                  </mat-option>
                  <mat-option >
                      <!-- <mat-option *ngFor="let food of foods" [value]="food.value"> -->
                        COM
                </mat-option>
                <mat-option >
                    <!-- <mat-option *ngFor="let food of foods" [value]="food.value"> -->
                      COM
              </mat-option>

                </mat-select>
              </mat-form-field>
          </div>
        </mat-card-actions>

        <mat-card-content class="">
                <div class="simply-map">
                    <button style="top: 17%; left: 57%;" [matMenuTriggerFor]="menu"  mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 24%; left: 54%;" [matMenuTriggerFor]="menu" mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 24%; left: 61%;" [matMenuTriggerFor]="menu" mat-mini-fab color="primary" class="map-link"></button>
                    <mat-menu #menu="matMenu">
                        <button  mat-menu-item>Item 1</button>
                        <button  mat-menu-item>Item 2</button>
                      </mat-menu>
                    <button style="top: 29%; left: 40%;" mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 29%; left: 40%;" mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 83%; left: 56%;" mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 37%; left: 78%;" mat-mini-fab color="primary" class="map-link"></button>
                    <button style="top: 12%; left: 68%;" mat-mini-fab color="primary" class="map-link"></button>
                </div>
        </mat-card-content>
      </mat-card>
    </div>